import * as React from 'react';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import {
  NumberInput,
  RowInput,
  StyledFlexRow,
  StyledInput,
} from '../Auth/WarehouseRegisterForm';
import { __ } from 'react-i18n/lib';
import { Required } from '../Auth/RegisterForm';
import { FormInput } from './FormInput';

interface Props {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  onChange: any;
  isB2B?: boolean;
  formProblems?: any;
}

function Address({
  street,
  streetNumber,
  city,
  zip,
  onChange,
  isB2B,
  formProblems = {},
}: Props) {
  const {
    streetProblem,
    streetNumberProblem,
    cityProblem,
    zipProblem,
  } = formProblems;
  return (
    <RowInput isB2B={isB2B} maxWidth={706} marginBottom={16}>
      <StyledFlexRow>
        <StyledInput marginRight={16} mobileMarginRight={16}>
          {(!!street || !isB2B) && (
            <FormInput
              required={true}
              justText={isB2B}
              name="street"
              type="text"
              label={__('Ulica')}
              value={isB2B ? `${street || ''}` : street}
              onChange={onChange}
              tabIndex={2}
              marginBottom={0}
              validMessage={streetProblem}
            />
          )}
        </StyledInput>
        {!isB2B && (
          <NumberInput marginRight={16}>
            <FormInput
              required={true}
              name="streetNumber"
              type="text"
              label={__('Číslo')}
              value={streetNumber}
              onChange={onChange}
              tabIndex={2}
              marginBottom={0}
              validMessage={streetNumberProblem}
            />
          </NumberInput>
        )}
      </StyledFlexRow>
      <StyledFlexRow isB2B={isB2B}>
        {(!!city || !isB2B) && (
          <StyledInput marginRight={16} mobileMarginRight={16}>
            <FormInput
              required={true}
              justText={isB2B}
              name="city"
              type="text"
              label={__('Mesto')}
              value={city}
              onChange={onChange}
              tabIndex={2}
              marginBottom={0}
              validMessage={cityProblem}
            />
          </StyledInput>
        )}
        {(!!zip || !isB2B) && (
          <NumberInput isB2B={isB2B}>
            <FormInput
              required={true}
              justText={isB2B}
              name="zip"
              type="text"
              label={__('PSČ')}
              value={zip}
              onChange={onChange}
              tabIndex={2}
              marginBottom={0}
              maxWidthPx={200}
              validMessage={zipProblem}
            />
          </NumberInput>
        )}
      </StyledFlexRow>
    </RowInput>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  flex-flow: row wrap;
`;

export { Address as DsiAddress };
